import { useEffect, useState } from "react";
import { FiledataApi } from "../services/akfenservicesprod/api";
import { useTranslation } from "react-i18next";
import moment from "moment";

function Portfolio() {
  const fileDataProdApi = new FiledataApi({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = fileDataProdApi;

  //#region Page Property
  const { t, i18n } = useTranslation();
  //#endregion

  const [selectedLang, setSelectedLang] = useState("");
  const [tableData, setTableData] = useState([]);

  const pageData = () => {
    if (api !== undefined && api !== "") {
      api
        .apiFiledataPortfolioGet(selectedLang === "tr-TR" ? 1 : 2)

        .then((response) => {
          if (response.status === 200) {
            let datas = response.data.data;
            console.log(datas);
            setTableData(datas);
          }
        });
    }
  };

  const formatNumber = (number) => {
    return number.toLocaleString("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatedDate = (value, index) => {
    if (value !== "" && value !== undefined && value.indexOf("T") !== -1) {
      const isoDate = value;
      const formatted = moment(isoDate).format("DD.MM.YYYY");
      return formatted;
    } else return value;
  };

  useEffect(() => {
    if (selectedLang !== "") pageData();
  }, [selectedLang]);

  useEffect(() => {
    if (window.location.pathname.indexOf("portfolio") !== -1) {
      i18n.changeLanguage("en");
      setSelectedLang("en-US");
    } else {
      setSelectedLang("tr-TR");
    }
  }, []);

  return (
    <>
      <div className="portfolio">
        <div className="pageHeader mb-4">
          <div className="title"> {t("PortfolioHeader")}</div>
        </div>
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="financialTable d-inline-block position-relative w-100 ">
              {tableData?.map((table, index) => (
                <>
                  <div key={index} className="itemTitle">
                    {table.category}
                  </div>
                  <table key={`table-+${index}`} className="w-100 mb-3">
                    <thead>
                      <tr>
                        {table.headers?.map((header, i) => (
                          <th key={i}>{header.title}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {table.rows?.map((data, it) => (
                        <tr>
                          {table.headers?.map((header, i) => (
                          <td key={it}>{data[header.title]}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Portfolio;
